import { AppState } from "./../types";
import { useSelector, shallowEqual } from "react-redux";

export const useAxiosInstance = () => {
  return useSelector((state: AppState) => state.axios.instance, shallowEqual);
};

export const useAxiosBaseURL = () => {
  return useSelector((state: AppState) => state.axios.baseURL);
};
